import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Paper,
} from "@mui/material";
import UserManualTable from "./ShowData";
import VideoTraining from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/AwasBandhu/ManualShow/VideoTraining";
import VideoTutorial from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/AwasBandhu/ManualShow/VideoTutorial";


const UserManualPopup = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabLabels = ["User Manual", "Video Tutorial","Training Video", "FAQ", "SOP", "Sample Drawing", "Building Byelaws and GO"];

  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  const TabPanel = ({ children, value, index }) => (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{
        p: 3,
        backgroundColor: "#fff",
        borderRadius: 1,
        boxShadow: 1,
        minHeight: 240,
      }}
    >
      {value === index && children}
    </Box>
  );

  return (
    <div>

      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "1.3rem",
          background: "linear-gradient(to right, #0c5a88, #1976d2)",
          color: "#fff",
          padding: "12px 20px", // Adjusted padding
          lineHeight: 1.0,
          position: "relative",
          minHeight: "60px", // Ensure consistent header height
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Manual & Documents
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {/* Tabs Header */}
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            mb: 2,
            mt: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { backgroundColor: "#0c5a88" } }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 1,
                mx: 0.5,
                backgroundColor: "#c5e3f6",
                color: "#0c3d64",
                minWidth: 140,
                "&.Mui-selected": {
                  backgroundColor: "#0c5a88",
                  color: "#fff",
                },
              },
            }}
          >
            {tabLabels.map((label, index) => (
              <Tab key={index} label={label} />
            ))}
          </Tabs>
        </Paper>

        {/* Tab 0: User Manual */}
        <TabPanel value={activeTab} index={0}>
          <UserManualTable tenantId="hp" formType="manual" isSubApproved="User Manual" />
        </TabPanel>

        {/* Video Tutorial */}
        <TabPanel value={activeTab} index={1}>
           <UserManualTable tenantId="hp" formType="manual" isSubApproved="Video Tutorial" />
        </TabPanel>

         {/* Training Video */}
        <TabPanel value={activeTab} index={2}>
           <UserManualTable tenantId="hp" formType="manual" isSubApproved="Training Video" />
        </TabPanel>

        {/* FAQ */}
        <TabPanel value={activeTab} index={3}>
            <UserManualTable tenantId="hp" formType="manual" isSubApproved="FAQ" />
        </TabPanel>

            {/* SOP */}
        <TabPanel value={activeTab} index={4}>
           <UserManualTable tenantId="hp" formType="manual" isSubApproved="SOP" />
        </TabPanel>

        {/* Sample Drawing */}
        <TabPanel value={activeTab} index={5}>
           <UserManualTable tenantId="hp" formType="manual" isSubApproved="Sample Drawing" />
        </TabPanel>

        {/* Building Byelaws and GO */}
        <TabPanel value={activeTab} index={6}>
            <UserManualTable tenantId="hp" formType="manual" isSubApproved="Building Byelaws and GO" />
        </TabPanel>
      </DialogContent>
    </div>
  );
};

export default UserManualPopup;